// extracted by mini-css-extract-plugin
export default {"Errors":"Errors_Errors__BhHzh"};